import setMsHighContrastMode from '../mutators/setMsHighContrastMode';
import { MsHighContrastMode } from '../store/schema/MsHighContrastMode';
import { getStore } from '../store/store';

/**
 * We cannot use addEventListener until macOS BigSur+ is minimum for OWA. Before that,
 * MediaQueryList does not inherit from EventTarget. See PR 71489 for how to make
 * the change when it does.
 */
export default function initializeIsMsHighContrastState() {
    const mediaQuery = window.matchMedia('screen and (-ms-high-contrast: active)');
    mediaQuery.addListener(handleHighContrastActiveChange);
    handleHighContrastActiveChange(mediaQuery);

    const mediaQueryHcWhiteOnBlack = window.matchMedia(
        'screen and (-ms-high-contrast: white-on-black)'
    );
    mediaQueryHcWhiteOnBlack.addListener(handleHighContrastWhiteOnBlackChange);
    handleHighContrastWhiteOnBlackChange(mediaQueryHcWhiteOnBlack);

    const mediaQueryHcBlackOnWhite = window.matchMedia(
        'screen and (-ms-high-contrast: black-on-white)'
    );
    mediaQueryHcBlackOnWhite.addListener(handleHighContrastBlackOnWhiteChange);
    handleHighContrastBlackOnWhiteChange(mediaQueryHcBlackOnWhite);
}

// media query change
// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7006 (32,41): Parameter 'mediaQuery' implicitly has an 'any' type.
// @ts-expect-error
function handleHighContrastActiveChange(mediaQuery) {
    // toggle store value if media query match is different than current state
    if (!mediaQuery.matches && getStore().mode !== MsHighContrastMode.None) {
        setMsHighContrastMode(MsHighContrastMode.None);
    }
}

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7006 (42,47): Parameter 'mediaQuery' implicitly has an 'any' type.
// @ts-expect-error
function handleHighContrastWhiteOnBlackChange(mediaQuery) {
    // toggle store value if media query match is different than current state
    if (mediaQuery.matches && getStore().mode !== MsHighContrastMode.HighContrastWhiteOnBlack) {
        setMsHighContrastMode(MsHighContrastMode.HighContrastWhiteOnBlack);
    }
}

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7006 (52,47): Parameter 'mediaQuery' implicitly has an 'any' type.
// @ts-expect-error
function handleHighContrastBlackOnWhiteChange(mediaQuery) {
    // toggle store value if media query match is different than current state
    if (mediaQuery.matches && getStore().mode !== MsHighContrastMode.HighContrastBlackOnWhite) {
        setMsHighContrastMode(MsHighContrastMode.HighContrastBlackOnWhite);
    }
}
